import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import color from "./Loader.style";

const Loader = ({
  size,
  className
}) => ___EmotionJSX(CircularProgress, {
  size: size,
  css: color,
  className: className
});

Loader.defaultProps = {
  size: 25,
  className: ''
};
Loader.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
};
export default Loader;